export default __webpack_public_path__ + "static/media/README.bd4a3e7f.md";